import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClearState } from '../../DataStore/useClearState';
import functions from '../../util/functions';
import { useAuth } from '../../DataStore/AuthContext';
import ajaxUser from '../../util/remote/ajaxUser';

const UserProfile = () => {

    const {user, getMyProfile} = useAuth();
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        getMyProfile();
    }, []);

    const navigate = useNavigate();

    const clearAllState = useClearState();

    const handleLogout = ()=>{
        // Clear all states and remove token
        clearAllState();
        localStorage.removeItem('eschool@user');
        navigate('/login');
    }

    const hanldeProfileExit = async()=>{
        if(loading){
            return;
        }
        setLoading(true);
        const server_response = await ajaxUser.exitProfile();
        setLoading(false);
        if(server_response.status === "OK"){
            navigate('/switch');
            window.location.reload();
        }
    }

    const tokenInfo = functions.readUser();

    return (
        <div className="heade-btn-lg pr-0">
        <div className="widget-content p-0">
            <div className="widget-content-wrapper">
                <div className="widget-content-left">
                    <div className="btn-group">
                        <button
                            type="button"
                            className="p-0 btn"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {user && <img
                                width="42"
                                className="rounded-circle"
                                src={user.photo}
                                alt=""
                            />}
                            <i className="fa fa-angle-down ml-2 opacity-8"></i>
                        </button>
                        <ul className="dropdown-menu dropdown-menu-right">

                            <li className="dropdown-header">Profile Options</li>
                            <li><button className="dropdown-item" onClick={hanldeProfileExit}>Exit School Profile</button></li>
                            <li><button className="dropdown-item">Change Password</button></li>
                            <li><div className="dropdown-divider"></div></li>
                            <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                        </ul>
                    </div>
                </div>
                <div className="widget-content-left ml-3 header-user-info">
                    <div className="widget-heading">{user ? user.first_name + ' ' + user.last_name  : '...'}</div>
                    <div className="widget-subheading">{tokenInfo.username}</div>
                </div>
                <div className="widget-content-right header-user-info ml-3">
                    <button type="button" className="btn-shadow p-1 btn btn-primary btn-sm">
                        <i className="fa text-white fa-calendar pr-1 pl-1"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    );
};

export default UserProfile;